// extracted by mini-css-extract-plugin
export var icon = "_3y-1";
export var subtext = "_3y-0";